import { useSectionNavTheme } from "@/app/hooks/useSectionNavTheme";
import { cn } from "@/app/utils/className";
import Image from "next/image";
import { useRef } from "react";

interface SectionSeparatorProps {
  imageUrl: string;
  dataSpeed?: string;
  overlayClassName?: string;
  imageClassName?: string;
}

export const SectionSeparator = ({
  imageUrl,
  overlayClassName,
  imageClassName,
  dataSpeed = "0.5",
}: SectionSeparatorProps) => {
  const separatorRef = useRef<HTMLDivElement | null>(null);
  useSectionNavTheme({
    trigger: ".section-separator",
    isDark: false,
  });

  return (
    <div
      ref={separatorRef}
      className="section-separator relative w-full h-64 lg:h-96 bg-gradient-to-b from-white dark:from-slate-900 to-transparent pointer-events-none overflow-hidden"
    >
      <div className="relative" data-speed={dataSpeed}>
        <Image
          src={imageUrl}
          alt="" // Decorative image - no alt text needed
          className={cn(
            "w-auto h-90 object-cover lg:min-w-[1800px] lg:h-auto -top-[32px] lg:-top-[100px] relative",
            imageClassName
          )}
          draggable={false}
          height={800}
          width={1800}
        />
        <div
          className={cn(
            "overlay absolute -inset-[300px] bg-gradient-to-b from-black/40 to-black/60 pointer-events-none",
            overlayClassName
          )}
        ></div>
      </div>
    </div>
  );
};
